<template>
  <el-dialog
    title="Restrictionare login IP"
    id="popup_dialog" 
    :visible.sync="showPopup"
    class="my-dialog-class"
  >
    <el-form
      label-position="left"
      :inline="false"
      :model="selectedObject"
      ref="my-form"
      @submit.prevent="save"
      v-loading="loadingVisible"
    >
      <el-row :gutter="15">

        <el-col  class="input-element" >
          <el-form-item >
            <el-checkbox class="full-width" v-model="selectedObject.PermiteAccesIP" true-label="1" false-label="0">
              Activat
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>

        <el-row :gutter="15" v-if="Boolean(Number(selectedObject.PermiteAccesIP))">
          <el-form-item
             v-for="(product, i) in selectedObject.ListaIP"
            :key="'element_lista_ip_' + i"
            :label="i+1 + ':'"
            :prop="'ListaIP['+ i + '].IP'"
            :rules="{
              required: true,
              message: 'Campul este obligatoriu',
              trigger: 'blur',
            }"
          >
           <el-input v-model='product.IP'>
           <el-button
              v-if="selectedObject.ListaIP.length > 1"
              type="danger"
              slot="append"
              @click="delete_item(i)"
              class="list-btn"
              icon="el-icon-delete"
              ></el-button>
           </el-input>
          </el-form-item>        
          <el-button
              type="success"
              :disabled="! Boolean(Number(selectedObject.PermiteAccesIP))"
              @click="add_item()"
              class="list-btn"
              icon="el-icon-plus"
              ></el-button>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showPopup = false"> Renunta </el-button>
      <el-button type="primary" @click="save"> Salveaza </el-button>
    </span>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Utilizatori_dialog",
  extends: BasePage,
  data() {
    return {
      showPopup: false,
      selectedObject: {
        PermiteAccesIP: 0,
        ListaIP: []
      },
    };
  },

  methods: {
    delete_item: async function (index) {
      this.selectedObject.ListaIP.splice(index, 1);
    },
    add_item: async function () {
      let nou = {"Id": "", IP:""}
      this.selectedObject.ListaIP.push(nou);
    },

    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    show_me: async function (id) {
      
        var result = await this.post("utilizatori/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
        this.showPopup = true;
    },
    save: async function () {
      this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          await this.post("utilizatori/save_ips", {
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.$emit("save");
        }
      });
    },
  },
  mounted: function () {
  },
};
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}

.input-element {
  width: 50%;
}

@media only screen and (max-width: 600px) {
  width: 100%;
}
</style>